




















































































import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {translate} from "@/services/translation/translation";
import './_color-picker.less';
import $ from 'jquery';
//import typeahead from '../../../../node_modules/corejs-typeahead/dist/typeahead.jquery.min.js';
import typeahead from '../../../../node_modules/corejs-typeahead/dist/typeahead.bundle.min.js';
import Bloodhound from '../../../../node_modules/bloodhound-js/lib/bloodhound.js'
import Handlebars from '../../../../node_modules/handlebars/dist/handlebars'
import {goToTop} from "@/services/position/position";
import {string} from "prop-types";
import vueSlider from 'vue-slider-component'
import Slick from "vue-slick";
import { getColorSortingGroups } from '../../../services/webclient/webclient';

@Component({
    components: {
        Slick
    },
    data() {
        return {
            qr: window.usePromoSystem.qrCode()
        }
    }
})

export default class ColorPicker extends Vue {
    @Prop() model;

    private data: any = {
        model: 0
    };
    public shiftType = 'group'; // group / smart
    public rowSetting = 9;
    public shiftSetting = 0;
    public ignoreGrouping = false;
    public className = '';
    public colorPickerId = '';
    public colorHexa = '';
    public colorRGB = '';
    public colorName = '';
    public selectedColor = '';
    public defaultColorIdT = '';
    public allColors = [];
    public mosaikRegexp = /^(M)([0-9])+$/;
    public slickOptions = {
        dots: false,
        infinite: true,
        centerMode: false,
        rows: 0,
        slidesToShow: 13,
        slidesToScroll: 13,
        responsive: [{
            breakpoint: 1280,
            settings: {
                slidesToShow: 13,
                slidesToScroll: 13
            }
        },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6 
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            }
        ]
    };
    public slickFugueOptions = {
        dots: false,
        infinite: true,
        centerMode: false,
        rows: 0,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
            breakpoint: 1280,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5
            }
        },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            }
        ]
    };


    async mounted() {
        goToTop('', this.model.componentSetting.id);
        this.colorPickerId = this.model.id;

        console.log('C:',this.model.componentSetting)
        this.allColors = this.sortColor(this.model.componentSetting.items);
        if(typeof this.model.componentSetting.default != "undefined"){
            this.defaultColorIdT = this.model.componentSetting.default;
        }else{
            this.defaultColorIdT = this.model.componentSetting.items[0].id;
        }
        
        if (!this.ignoreGrouping) {
            this.allColors = await this.groupingColors(this.allColors);
        }

        this.initTypheadSearch(this.model.componentSetting.items);

        setTimeout(() => {
            this.initAction();
        },300)
    }

    handleAfterChange() {
        this.selectDefaultColor();
    }

    sortColor(colors){

        let sortedColors = [];
        /*
        for (let i = 0; i < 116; i++) {
            colors.forEach(function (elem) {
                if(elem.name.indexOf((i + 1).toString().padStart(3, '0')) == 0 && elem.name.lastIndexOf(1) != 3){
                    sortedColors.push(elem);
                }
            });
        }

        let lifeOne = colors.filter(function(elem) {
            return elem.name.lastIndexOf(1) == 3
        });

        sortedColors = sortedColors.concat(lifeOne);


        let mosaikRegexp = /^(M|S)([0-9])+$/

        let mosaik = colors.filter(function(elem) {
            return mosaikRegexp.test(elem.name);
        });

        sortedColors = sortedColors.concat(mosaik);

        let premiumfugeRegexp = /^([A-Za-z ()])+$/

        let premiumfuge = colors.filter(function(elem) {
            return premiumfugeRegexp.test(elem.name);
        });
        sortedColors = sortedColors.concat(premiumfuge);

        let ralRegexp = /^(RAL )([0-9])+$/

        let ralcolors = colors.filter(function(elem) {
            return ralRegexp.test(elem.name);
        });
        sortedColors = sortedColors.concat(ralcolors);

        let lasurRegexp = /^([0-9])\w+(L)$/

        let lasur = colors.filter(function(elem) {
            return lasurRegexp.test(elem.name.split(' ')[1]);
        });
        sortedColors = sortedColors.concat(lasur);

        let metallicRegexp = /^([0-9])\w+(M)$/

        let metallic = colors.filter(function(elem) {
            return metallicRegexp.test(elem.name.split(' ')[1]);
        });

        sortedColors = sortedColors.concat(metallic);

        let glitterRegexp = /^([0-9])\w+(G)$/

        let glitter = colors.filter(function(elem) {
            return glitterRegexp.test(elem.name.split(' ')[1]);
        });

        sortedColors = sortedColors.concat(glitter);
        */
        sortedColors = colors.sort((a,b)=>{
            let aBase = a.name.split(' ')[0];
            let bBase = b.name.split(' ')[0];
            //return aBase.localeCompare(bBase) - bBase.localeCompare(aBase);
            return a.sort_number - b.sort_number || aBase.localeCompare(bBase);
        });
        return sortedColors;
    }

    async groupingColors(colors) {
    const { colorsortingGroups: colorSortingGroups } = await getColorSortingGroups();
    let groupedColors = [];

    if (colorSortingGroups) {
        let orderedSortingGroups = [...colorSortingGroups.sort((a, b) => a.sort_number - b.sort_number), { id: null }]
        orderedSortingGroups.forEach(group => {
            let groupColors = colors.filter(c => group.id == c.color_sorting_group_id);
            if (group.id === null) {
                for (let i = 0; i < this.shiftSetting; i++) {
                    groupColors.unshift({ id: -1 });
                }
            }
            groupColors.forEach(c => {
                groupedColors.push(c);
            });

            if (this.shiftType == 'group') {
                let rest = groupColors.length % this.rowSetting;
                if (rest > 0) {
                    let emptys = this.rowSetting - rest;
                    for (let i = 0; i < emptys; i++) {
                        groupedColors.push({ id: -1 });
                    }
                }
            }
        });
        if (this.shiftType == 'smart') {
            return groupedColors.reduce((acc: any, val: any, i) => {

                let isString = isNaN(val.name)
                let isPrevString = false;
                let prev: any = acc[acc.length - 1]

                if (prev) {
                    isPrevString = isNaN(prev.name)
                    if (prev.name === val.name) return acc; // skip duplicates
                }

                if (prev && val.id !== -1) {
                    if (isString !== isPrevString || Number(prev.name.slice(-1)) - Number(val.name.slice(-1)) > 2) {
                        let rest = acc.length % this.rowSetting;
                        if (rest > 0) {
                            let emptys = this.rowSetting - rest;
                            for (let i = 0; i < emptys; i++) {
                                acc.push({ id: -1 }); // fill up column with empty cells
                            }
                        }
                    }
                }
                acc.push(val)
                return acc;
            }, []);
        }
    }
    return groupedColors;
}

    updated(){
        this.reInit();
        this.initAction();
    }


    activated() {
        this.reInit();
        this.initAction();
    }


    trans(key) {
        return translate(key);
    }


    @Watch("defaultColorIdT", {immediate: true, deep: true})
    changeComponentSettingModel(newValue) {
        let componentValue: any = {};

        let self = this;
        $.each(this.model.componentSetting.items, function (index, element) {
            if(newValue == element.id){
                componentValue.id = self.model.componentSetting.id;
                componentValue.name = self.model.componentSetting.name;
                componentValue.value = newValue;
                componentValue.value_id = self.model.componentSetting.id;
                componentValue.next_question = self.model.componentSetting.next_question;
                componentValue.isEnableNext = self.model.isEnableNext;
            }
        });

        this.onSelectedQuestionValue(componentValue);


    }




    @Emit("selectedQuestionValue")
    onSelectedQuestionValue(value) {
    }


    public initTypheadSearch(colorPalette) {
        var self = this;
        var list = [];
        colorPalette.forEach(function (value, index) {
            if (typeof value.name !== "undefined") {
                list[index] = value.name;
            }
        });

        function colorPaletteWhiteDefaults(q, sync) {
            if (q === '') {
                sync(colorPaletteBloodhound.get(list));
            } else {
                colorPaletteBloodhound.search(q, sync);
            }
        }


        var colorPaletteBloodhound = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            identify: function (obj) {
                return obj.name;
            },
            local: colorPalette
        });

        $('.colorSerachTyphead').typeahead({
                hint: true,
                highlight: true,
                minLength: 0,
            },
            {

                limit: 10000,
                display: 'name',
                name: 'name',
                source: colorPaletteWhiteDefaults,
                templates: {
                    suggestion: function (data) {
                        return '<div class="color-select-option"><div class="name"><p>' + data.name + '</p></div><div class="color" style="background-color: #' + data.hex + '"></div></div>';
                    }
                }
            }).on('typeahead:select', function (e, o) {

            $('.colorSerachTyphead').val(o.name);
            self.changeComponentSettingModel(o.id);

            $('#' + self.colorPickerId + '' + self.className + ' .color-calculator').removeClass('black');

            console.log($('#' + self.colorPickerId + ' .color-calculator[data-name="' + o.name + '"]'));

            $('#' + self.colorPickerId + ' .color-calculator[data-name="' + o.name + '"]').addClass('black');
            var index = $('.color-calculator[data-name="' + o.name + '"]').parent().parent().attr('data-slick-index');
            console.log('goTo Index', index);
            $('#' + self.colorPickerId + ' .slick-slider').slick('slickGoTo', index)

        });
    }


    public drawColorDetail(colorHexa, colorRGB, colorName, parent) {



        $('.color-detail-calculator').addClass('visible');

        if (colorName == '0019' || colorName == 'White' ) {

            $(parent + ' .color-detail-calculator .color-image').addClass('white');

        }else{

            $(parent + ' .color-detail-calculator .color-image').removeClass('white');
        }

        var rgb = colorRGB.replace(/rgb|\(|\)/g, '').replace(/\, /g, '/');

        $(parent + ' .color-detail-calculator .color-image').css('background', 'none left top no-repeat ' + colorRGB);
        $(parent + ' .color-detail-calculator .color-name').html(colorName);
        $(parent + ' .color-detail-calculator .color-code').show();
        $(parent + ' .color-detail-calculator .color-code span.hex').html(colorHexa);
        $(parent + ' .color-detail-calculator .color-code span.rgb').html(rgb);
    }

    public getBgColorHex(elem) {
        var color = elem.css('background-color');
        var hex;
        if (color.indexOf('#') > -1) {
            hex = color;
        } else {
            var rgb = color.match(/\d+/g);
            hex = '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2);
        }
        return hex;
    }


    public selectDefaultColor() {
        $('.color-calculator[data-id="' + this.defaultColorIdT + '"]').addClass('black');
        var index = $('.color-calculator[data-id="' + this.defaultColorIdT + '"]').parent().parent().attr('data-slick-index');
        console.log('id:',this.defaultColorIdT,'item:', $('.color-calculator[data-id="' + this.defaultColorIdT + '"]'), 'parent:',$('.color-calculator[data-id="' + this.defaultColorIdT + '"]').parent().parent().data('slick-index'))
        $('#' + this.colorPickerId + ' .slick-slider').slick('slickGoTo', index)
    }

    public initAction() {
        var self = this;

        this.selectDefaultColor();


        $('#' + self.colorPickerId + self.className + ' .color-calculator').click(function () {
            let $col = $(this);
            self.selectedColor = $col.data('id');
            if (!self.selectedColor || self.selectedColor == '-1') {
                return;
            }
            self.colorHexa = $col.data('hex');
            self.colorRGB = $col.css('background-color');
            self.colorName = $col.data('name');
            var className = self.className;
            self.drawColorDetail(self.colorHexa, self.colorRGB, self.colorName, className);
        });

        $('#' + self.colorPickerId + this.className + ' .close-button').click(function () {

            $('#' + self.colorPickerId + ' .color-detail-calculator').removeClass('visible');
        });

        $('#' + self.colorPickerId + this.className + ' .color-pickup').click(function () {
            $('#' + self.colorPickerId + self.className + ' .color-calculator').removeClass('black');
            $('.color-calculator[data-name="' + self.colorName + '"]').addClass('black');
            self.changeComponentSettingModel(self.selectedColor);
            $('.colorSerachTyphead').val(self.colorName);
            $('#' + self.colorPickerId + ' .color-detail-calculator').removeClass('visible');
        });


    }

    reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
            this.$refs.slick.reSlick();
        });
    }


}

